import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { Col, Row } from "react-bootstrap";
import InfiniteScroll from "react-infinite-scroll-component";
import BackButton from "../components/microComponents/BackButton";
import QuestionApi from "../api/services/QuestionApi";
import scrollToTop from "../components/ScrollTop/ScrollTop";
import moment from "moment";
import QuestionResultCard, {
  QuestionResultCardSkeleton,
} from "../components/QuestionResultCard/QuestionResultCard";
import ScoreCard from "../components/ScoreCard/ScoreCard";
import useCourseStore from "../stores/useCourseStore";

interface QuestionDetail {
  id: number;
  title: string;
  description?: string;
  has_participated: boolean;
  my_position?: number;
  batch?: {
    id: number;
    name: string;
    media?: string;
  };
  user_result?: {
    correct_answers: number;
    total_answered: number;
  };
}

interface TopParticipant {
  id: number;
  name: string;
  profile_pic?: string;
  submitted_at: string;
  total_answered: number;
  correct_answers: number;
  score: number;
}

interface Quiz {
  id: number;
  question: string;
  answer: boolean;
  user_answer?: boolean;
  [key: string]: any;
}

const QuestionsDetails: React.FC = () => {
  const navigate = useNavigate();
  const { id } = useParams<{ id: string }>();
  const [isLoading, setIsLoading] = useState(false);
  const [questionDetail, setQuestionDetail] = useState<QuestionDetail | null>(
    null
  );
  const [topParticipants, setTopParticipants] = useState<TopParticipant[]>([]);
  const [nextPageNo, setNextPageNo] = useState(0);
  const originalQuizList = useCourseStore((state) => state.originalQuizList);
  const setOriginalQuizList = useCourseStore(
    (state) => state.setOriginalQuizList
  );
  const setQuizList = useCourseStore((state) => state.setQuizList);

  useEffect(() => {
    scrollToTop();
    if (id) {
      fetchApiData();
    }
  }, [id]);

  const fetchApiData = () => {
    if (!id) return;

    setIsLoading(true);

    QuestionApi.getQuestionSetById(Number(id), 1, {
      onSuccess: (response) => {
        setIsLoading(false);
        const { top_participants, user_submissions, quizzes, ...restResponse } =
          response.data;

        setQuestionDetail(restResponse);
        setTopParticipants(response.data?.top_participants?.data || []);
        setNextPageNo(
          response.data?.top_participants?.meta?.next_page_url ? 2 : 0
        );

        if (response.data?.user_submissions?.length > 0) {
          const submissionsMap = Object.fromEntries(
            response.data.user_submissions.map((item: any) => [
              item.quiz_id,
              item,
            ])
          );

          // const formatedQuize = response.data.quizzes.map((item: any) => {
          //   const match = submissionsMap[item.id];
          //   return {
          //     ...item,
          //     answer: item.answer == "1" ? true : false,
          //     user_answer: match ? match.given_answer === "1" : undefined,
          //   };
          // });

          const formatedQuize = response.data.quizzes.reduce(
            (result: any[], item: any) => {
              const match = submissionsMap[item.id];

              result.push({
                ...item,
                answer: item.answer == "1" ? true : false,
                user_answer: match ? match.given_answer === "1" : undefined,
              });

              return result;
            },
            []
          );

          setOriginalQuizList(formatedQuize);
          setQuizList(JSON.parse(JSON.stringify(formatedQuize)));
        } else {
          const formatedQuize = response.data?.quizzes.reduce(
            (result: any[], item: any) => [
              ...result,
              { ...item, answer: item.answer == "1" ? true : false },
            ],
            []
          );
          setOriginalQuizList(formatedQuize);
          setQuizList(JSON.parse(JSON.stringify(formatedQuize)));
        }
      },
      onError: () => setIsLoading(false),
    });
  };

  const handleLoadMore = () => {
    if (!isLoading && nextPageNo > 0 && id) {
      setIsLoading(true);

      QuestionApi.getQuestionSetById(Number(id), nextPageNo, {
        onSuccess: (response) => {
          setIsLoading(false);
          setTopParticipants((prev) => [
            ...prev,
            ...(response.data?.top_participants?.data || []),
          ]);
          setNextPageNo(
            response.data?.top_participants?.meta?.next_page_url
              ? nextPageNo + 1
              : 0
          );
        },
        onError: () => setIsLoading(false),
      });
    }
  };

  const renderSkeleton = () => (
    <Row className="questionDetails">
      {Array.from({ length: 4 }).map((_, index) => (
        <Col className="item_col" xs={12} md={6} key={index}>
          <QuestionResultCardSkeleton />
        </Col>
      ))}
    </Row>
  );

  // console.log("originalQuizList", originalQuizList);
  return (
    <div className="Container pb-4">
      <div className="questionDetails_main">
        <div className="titleSec">
          <BackButton title={"সফলতার মেডিসিন এখানে"} />
        </div>

        {isLoading && topParticipants.length === 0 ? (
          renderSkeleton()
        ) : (
          <>
            {originalQuizList && (
              <div className="quiz-exam-card">
                <div className="quiz-exam-header">
                  <img
                    src={
                      questionDetail?.has_participated
                        ? require("../assets/manik_view_exam.png")
                        : require("../assets/manik_start_exam.png")
                    }
                    alt="exam"
                    className="exam-image"
                  />
                  <div className="exam-info">
                    <h3 className="exam-title">
                      {questionDetail?.has_participated
                        ? "পরবর্তী পরীক্ষার জন্য গভীরভাবে প্রস্তুতি নেন"
                        : "বিসমিল্লাহ বলে পরীক্ষা শুরু করুন"}
                    </h3>
                    <button
                      className="exam-button"
                      onClick={() => {
                        // Navigate to quiz exam
                        navigate(
                          `/quiz-exam/QUESTIONSET?qSetId=${questionDetail?.id}&viewOnly=${questionDetail?.has_participated}`
                        );
                      }}
                    >
                      {questionDetail?.has_participated
                        ? "View Exam"
                        : "Start Exam"}
                    </button>
                  </div>
                </div>

                {questionDetail?.user_result && (
                  <div className="user-results">
                    <ScoreCard
                      score={questionDetail?.my_position || 0}
                      title="Position"
                      color="#000000"
                    />
                    <ScoreCard
                      score={questionDetail?.user_result.correct_answers}
                      title="Risposte corrette"
                      color="#4CAF50"
                    />
                    <ScoreCard
                      score={
                        questionDetail?.user_result.total_answered -
                        questionDetail?.user_result.correct_answers
                      }
                      title="Errori da ripassare"
                      color="#F44336"
                    />
                    <ScoreCard
                      score={
                        questionDetail?.user_result.correct_answers < 27 ? (
                          <i className="emoji">😢</i>
                        ) : (
                          <i className="emoji">🏆</i>
                        )
                      }
                      title={
                        questionDetail?.user_result.correct_answers < 27
                          ? "Non Superato!"
                          : "Superato!"
                      }
                      color={
                        questionDetail?.user_result.correct_answers < 27
                          ? "#F44336"
                          : "#4CAF50"
                      }
                    />
                  </div>
                )}
              </div>
            )}

            {topParticipants?.length > 0 && (
              <h2 className="section-title">সেরা পারফর্মার</h2>
            )}

            <InfiniteScroll
              dataLength={topParticipants?.length}
              next={handleLoadMore}
              hasMore={nextPageNo > 0 ? true : false}
              loader={renderSkeleton()}
            >
              <Row className="questionDetails">
                {topParticipants.map((item, index) => (
                  <Col className="item_col" xs={12} md={6} key={index}>
                    <QuestionResultCard
                      position={index + 1}
                      name={item.name}
                      profilePic={item.profile_pic}
                      batchName={questionDetail?.batch?.name || ""}
                      submittedDate={moment
                        .utc(item.submitted_at)
                        .format("DD MMM YYYY, hh:mm A")}
                      totalQuize={item.total_answered}
                      correct={item.correct_answers}
                      error={item.total_answered - item.correct_answers}
                      noAnswer={item.score}
                    />
                  </Col>
                ))}
              </Row>
            </InfiniteScroll>
          </>
        )}
      </div>
    </div>
  );
};

export default QuestionsDetails;
